// lingland-frontend/src/pages/HowItWorksPage.js
/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import SchemaMarkup from '../components/SchemaMarkup';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { UploadCloud, FileSearch, BadgePercent, CreditCard, MailOpen, MessageSquare, CheckCircle } from 'lucide-react';
import './HowItWorksPage.css';

const ProcessStep = ({ stepNumber, icon: Icon, title, description, isVisible, t }) => (
    <div className={`process-step animate-on-scroll ${isVisible ? 'is-visible' : ''}`}>
        <div className="step-header">
            <div className="step-icon-wrapper">
                <Icon size={32} strokeWidth={1.5} />
            </div>
            <span className="step-number">{t('how_step')} {stepNumber}</span>
            <h3>{title}</h3>
        </div>
        <div className="step-description">
            <p>{description}</p>
        </div>
    </div>
);

function HowItWorksPage() {
    const { t } = useTranslation();
    const [titleRef, isTitleVisible] = useIntersectionObserver();
    const [step1Ref, isStep1Visible] = useIntersectionObserver();
    const [step2Ref, isStep2Visible] = useIntersectionObserver();
    const [step3Ref, isStep3Visible] = useIntersectionObserver();
    const [step4Ref, isStep4Visible] = useIntersectionObserver();
    const [step5Ref, isStep5Visible] = useIntersectionObserver();
    const [step6Ref, isStep6Visible] = useIntersectionObserver();
    const [ctaRef, isCtaVisible] = useIntersectionObserver();

    return (
        <>
            <SEO
                title={t('how_header_title')}
                description={t('how_header_subtitle')}
                url="/jak-to-dziala"
            />
            <SchemaMarkup 
                type="BreadcrumbList" 
                data={{
                    breadcrumbs: [
                        { name: 'Strona główna', url: '/' },
                        { name: 'Jak to działa', url: '/jak-to-dziala' }
                    ]
                }}
            />
            <section ref={titleRef} className={`page-header-section section-bg-white animate-on-scroll ${isTitleVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h1>{t('how_header_title')}</h1>
                    <p className="subtitle">{t('how_header_subtitle')}</p>
                </div>
            </section>

            <section className="process-steps-section section-bg-light-gray">
                <div className="container">
                    <div className="process-steps-wrapper">
                        <div className="process-line"></div>

                        <div ref={step1Ref}>
                            <ProcessStep
                                stepNumber={1} icon={UploadCloud}
                                title={t('how_step1_title')} description={t('how_step1_desc')}
                                isVisible={isStep1Visible} t={t}
                            />
                        </div>
                        <div ref={step2Ref}>
                             <ProcessStep
                                stepNumber={2} icon={FileSearch}
                                title={t('how_step2_title')} description={t('how_step2_desc')}
                                isVisible={isStep2Visible} t={t}
                            />
                        </div>
                       <div ref={step3Ref}>
                             <ProcessStep
                                stepNumber={3} icon={BadgePercent}
                                title={t('how_step3_title')} description={t('how_step3_desc')}
                                isVisible={isStep3Visible} t={t}
                            />
                       </div>
                        <div ref={step4Ref}>
                            <ProcessStep
                                stepNumber={4} icon={CreditCard}
                                title={t('how_step4_title')} description={t('how_step4_desc')}
                                isVisible={isStep4Visible} t={t}
                            />
                        </div>
                        <div ref={step5Ref}>
                            <ProcessStep
                                stepNumber={5} icon={CheckCircle}
                                title={t('how_step5_title')} description={t('how_step5_desc')}
                                isVisible={isStep5Visible} t={t}
                            />
                        </div>
                         <div ref={step6Ref}>
                             <ProcessStep
                                stepNumber={6} icon={MailOpen}
                                title={t('how_step6_title')} description={t('how_step6_desc')}
                                isVisible={isStep6Visible} t={t}
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section ref={ctaRef} className={`cta-how-end section-bg-white animate-on-scroll ${isCtaVisible ? 'is-visible' : ''}`}>
                 <div className="container text-center">
                    <h2>{t('how_cta_title')}</h2>
                    <p className="subtitle">{t('how_cta_subtitle')}</p>
                     <Link to="/kontakt" className="button-secondary">
                         <MessageSquare size={18} style={{ marginRight: '0.5rem' }}/> {t('how_cta_button')}
                     </Link>
                 </div>
            </section>
        </>
    );
}

export default HowItWorksPage;